import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import moment from 'moment';
import { FileInfoBlockProps } from '@components/ncFileVersions/types';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';
import { BOX_SHADOW_TYPE, notAvailableFieldText } from '@components/ncFileVersions/constants';
import getPcsCount from '@components/ncFileVersions/helpers/getPcsCount';

const FileInfoBlock: FC<FileInfoBlockProps> = ({ C, selectedVersion, ncFile }) => {
  const shadowStyles = getBoxShadowStyle({ type: BOX_SHADOW_TYPE, C });

  const pcsCount = getPcsCount(selectedVersion);
  const producedValue = typeof pcsCount === 'number' ? `${pcsCount} ${i18n.t('Pcs')}` : i18n.t(notAvailableFieldText);

  const fileInfoConfig = [
    {
      borderBottomRadius: false, borderTopRadius: true, onlyLabel: false, data: [], index: 0,
      i: { isText: false, name: 'Runs', ValueComponent: <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}>{producedValue}</Text> },
      C, loading: !ncFile,
    },
    {
      borderBottomRadius: false, borderTopRadius: false, onlyLabel: false, data: [], index: 0,
      i: { isText: false, name: 'First Cycle', ValueComponent: (
        <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}>
          {selectedVersion?.firstRanOn ? `${moment(selectedVersion?.firstRanOn).format('DD-MM-YYYY')} ${moment(selectedVersion?.firstRanOn).format('HH:mm')}` : i18n.t(notAvailableFieldText)}
        </Text>
      ) },
      C, loading: !ncFile,
    },
    {
      borderBottomRadius: false, borderTopRadius: false, onlyLabel: false, data: [], index: 0,
      i: { isText: true, name: 'First Cycle On', value: selectedVersion?.firstRanByMachineName ?? i18n.t(notAvailableFieldText) },
      C, loading: !ncFile,
    },
    {
      borderBottomRadius: false, borderTopRadius: false, onlyLabel: false, data: [], index: 0,
      i: { isText: false, name: 'Last Cycle', ValueComponent: (
        <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}>
          {selectedVersion?.lastRanOn ? `${moment(selectedVersion?.lastRanOn).format('DD-MM-YYYY')} ${moment(selectedVersion?.lastRanOn).format('HH:mm')}` : i18n.t(notAvailableFieldText)}
        </Text>
      ) },
      C, loading: !ncFile,
    },
    {
      borderBottomRadius: true, borderTopRadius: false, onlyLabel: false, data: [{}], index: 0,
      i: { isText: true, name: 'Last Cycle On', value: selectedVersion?.lastRanByMachineName ?? i18n.t(notAvailableFieldText) },
      C, loading: !ncFile,
    },
  ];

  return (
    <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
      {fileInfoConfig.map((c, i) => (
        <InputLine key={i} {...c} withoutStretchingForContainer layoutForPhone rightSideTakesAllSpace />
      ))}
    </View>
  );
};

export default FileInfoBlock;
